import axiosInstance from "../axiosInstance";
import Cookie from "js-cookie";

import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT_REQUEST,
} from "../constants/session";

const login = (params) => async (dispatch) => {
	Cookie.set("eys_login_info", params);
	dispatch({ type: LOGIN_REQUEST });
	try {
		const { data } = await axiosInstance.post("/web/stores", params);
		dispatch({
			type: LOGIN_SUCCESS,
			payload: data,
		});

		Cookie.set("userInfo", data.data);
	} catch (error) {
		console.log("error ", error);
		const message = error.response.data.error;
		dispatch({ type: LOGIN_FAIL, payload: message });
	}
};

const logout = () => async (dispatch) => {
	dispatch({ type: LOGOUT_REQUEST });
};

export { login, logout };
